<template>
  <AtomicUiHorizontalFacets
    name="facet"
    :options="facetsOptions"
    :disable-auto-outlined="true"
    @on-facet-click="facetClick"
    @on-close-facet-dropdown="facetDropdownClose"
  />
</template>

<script setup>
import useFacetOptions from '~/composables/filteringFacets/useFacetOptions';
import useSortFilter from '~/composables/filteringFacets/useSortFilter';
import useDisplay from '~/composables/filteringFacets/useDisplay';
import { GET_ALL_SELECTED_CRITERIA, ON_CLOSE_FACET_DROPDOWN } from '~/types/actions';
import { useFilteringFacetsStore } from '~/stores/filteringFacets';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

const filteringFacetsStore = useFilteringFacetsStore();
const slideoutStore = useSlideoutStore();

const { activeDropdown, facetsOptions, buildFacetsList } = useFacetOptions();
const { screen } = useDisplay();
const { buildSections } = useSortFilter();

const facetClick = (facet) => {
  if (screen.value.isMobile) {
    buildSections({
      facetId: facet.selected.id,
      sortBySelectedValue: filteringFacetsStore.sortBy.selectedValue,
      facets: filteringFacetsStore.facets,
    });
    slideoutStore.toggle('sort-and-filter');
  } else {
    activeDropdown.value = facet.dropdownRef;
  }
};

const facetDropdownClose = () => {
  activeDropdown.value = null;
  filteringFacetsStore[GET_ALL_SELECTED_CRITERIA]();
  filteringFacetsStore[ON_CLOSE_FACET_DROPDOWN]();
};

buildFacetsList(filteringFacetsStore);
</script>

<style lang="scss" scoped>
:deep(.checkbox-container) {
  margin-right: rem-calc(48);
}
</style>
